module.exports = __webpack_public_path__ + "img/doppio.8a4ce7e0.png";